/**
 * Default design tokens for the BIA chat widget.
 *
 * Every value here is a CSS custom property the host can override
 * via plain CSS, e.g.:
 *
 *   bi-explorer-ai-chat {
 *     --bia-primary: var(--q-primary);
 *     --bia-background: var(--q-page-bg);
 *   }
 *
 * Defaults aim for an editorial, refined look (warm cream paper +
 * deep ink indigo) rather than the generic chatbot purple.
 */
export const DEFAULT_TOKENS: Record<string, string> = {
  // Brand
  '--bia-primary': '#1A1A2E',
  '--bia-primary-text': '#FAFAF7',
  '--bia-accent': '#1A1A2E',

  // Surfaces
  '--bia-background': '#FFFFFF',
  '--bia-surface': '#F7F6F2',
  '--bia-hover-bg': 'rgba(15, 15, 14, 0.04)',

  // Header — separate so hosts can match the platform's toolbar color
  '--bia-header-bg': '#FFFFFF',
  '--bia-header-text': '#0F0F0E',
  '--bia-header-text-muted': '#6B6B66',
  '--bia-header-border': '#E8E5DC',

  // Text
  '--bia-text': '#0F0F0E',
  '--bia-text-muted': '#6B6B66',

  // Borders
  '--bia-border': '#E8E5DC',
  '--bia-border-light': '#F1EFE7',

  // Bubbles
  '--bia-user-bubble': 'var(--bia-primary)',
  '--bia-user-bubble-text': 'var(--bia-primary-text)',
  '--bia-ai-bubble': 'transparent',

  // Input
  '--bia-input-bg': '#FFFFFF',
  '--bia-input-border': 'var(--bia-border)',

  // Status
  '--bia-danger': '#B91C1C',
  '--bia-danger-bg': '#FEF2F2',

  // Typography
  '--bia-font-display': "'Fraunces', Georgia, 'Times New Roman', serif",
  '--bia-font-family': "'DM Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",

  // Shape
  '--bia-border-radius': '14px',
  '--bia-border-radius-sm': '10px',

  // Elevation
  '--bia-shadow-panel':
    '0 24px 60px -20px rgba(15, 15, 14, 0.18), 0 8px 24px -8px rgba(15, 15, 14, 0.10)',
  '--bia-shadow-launcher':
    '0 12px 32px -8px rgba(15, 15, 14, 0.30), 0 4px 12px -4px rgba(15, 15, 14, 0.18)',
};
